import CircleIcon from '@mui/icons-material/Circle'
import MicIcon from '@mui/icons-material/Mic'
import CircularProgress from '@mui/material/CircularProgress'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import ButtonComp from '../Button/Button'
import Skeleton from '@mui/material/Skeleton'
import { LinearProgress } from '@mui/material'
import Box from '@mui/material/Box'

export const MainAudioRecorderWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  borderRadius: theme.shape.customBorderRadius.main,
  backgroundColor: theme.palette.background.paper, //theme.WHITE
  width: '100%',
}))

export const ContentWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  padding: 15,
})

export const DefaultAudioPlayerWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  height: '12em',
  justifyContent: 'flex-end',
})

export const DeleteRecordButtonWrapper = styled(ButtonComp)(({ theme }) => ({
  marginTop: '32px',
  justifySelf: 'flex-end',
  fontSize: 14,
  fontWeight: 'normal',
  color: theme.palette.primary.main,
  letterSpacing: '0.15',
  '&.disabled': {
    color: theme.palette.grey[400], //theme.GREY
  },
}))

export const RecordPlayerWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '10vh',
})

export const StartRecordingWrapper = styled(ButtonComp)(({ theme }) => ({
  width: '150px',
  height: '12em',
  display: 'grid',
  placeItems: 'center',
  cursor: 'pointer',
  '&.disabled': {
    color: theme.palette.grey[400], //theme.GREY
    svg: {
      color: theme.palette.grey[400], //theme.GREY
    },
    span: {
      color: theme.palette.grey[400], //theme.GREY
    },
  },
}))

export const StartRecordingButtonWrapper = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
}))

export const PreviewRecordingWrapper = styled('div')({
  width: '300px',
  height: '12em',
  display: 'grid',
  placeItems: 'center',
  cursor: 'pointer',
})

export const SaveRecordingWrapper = styled('div')({
  display: 'flex',
  cursor: 'pointer',
  alignItems: 'center',
  marginTop: '20px',
  marginBottom: '10px',
  height: '5.3em',
})

export const CircleIconWrapper = styled(CircleIcon)(({ theme }) => ({
  color: theme.palette.error.main, //'red'
  marginBottom: -70,
}))

export const MicIconWrapper = styled(MicIcon)(({ theme }) => ({
  marginTop: '10px',
  color: theme.palette.error.main, //'red'
}))

export const CircularProgressWrapper = styled(CircularProgress)(
  ({ theme }) => ({
    color: theme.palette.error.main, //'red'
  }),
)

export const RecordAgainWrapper = styled('div')(({ theme }) => ({
  margin: '10px',
  color: theme.palette.primary.main,
}))

export const PreviewRecordingTextWrapper = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
}))

export const SkeletonWrapper = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.palette.background.default, //theme.LOADING_BLUE
}))

export const AudioMediaPlayerWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '95%',
  height: '20%',
  alignItems: 'center',
})

export const AudioMediaConrolsWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
})

export const AudioMediaProgressWrapper = styled(Box)({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
})

export const ProgressWrapper = styled(LinearProgress)({
  flex: 1,
  marginLeft: '4px',
  marginRight: '4px',
})
